import { computed } from 'vue';
import { state, url } from '../../core/vue/constants';
import viewSwitchTemplate from '../../../templates/components/molecules/view-switch.html';

export default {
    template: viewSwitchTemplate,
    setup() {
        const changeView = (view) => {
            state.view = view;

            url.searchParams.set('view', view);
            window.history.pushState(null, null, url.href);
        };

        const selectedView = computed(() => state.view);

        return {
            selectedView,
            changeView,
        };
    },
};
